import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { BONOS } from './salesData';
export function BonosSection() {
  return <section id="bonos" className="bg-white py-12 sm:py-16" data-id="element-38" data-mp="13d4fiklb3xpu">
      <div className="mx-auto max-w-5xl px-5" data-id="element-39" data-mp="13bkzmv3kbool">
        <div className="text-center" data-id="element-40" data-mp="ydrum5dzx0pw">
          <SectionTag className="bg-cream" data-id="element-41" data-mp="ycqfnptuzu2w">
            <GiftIcon className="h-3 w-3" aria-hidden strokeWidth={2.5} data-id="element-42" data-mp="tg02ba9fvcl6" />
            4 bonos de regalo
          </SectionTag>
          <h2 className="mx-auto mt-3.5 max-w-[24ch] font-display text-[1.5rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[32ch] sm:text-[2.2rem]" data-id="element-43" data-mp="ofvltk8j6huy">
            Los tomos te dan las recetas. Los bonos te{' '}
            <span className="mark-yellow" data-id="element-44" data-mp="fibfvxzq3xe0">ordenan la semana</span>.
          </h2>
          <p className="mx-auto mt-3 max-w-[44ch] font-sans text-[0.9rem] leading-relaxed text-taupe sm:max-w-2xl" data-id="element-45" data-mp="2esb86kvgksld">
            Vienen incluidos en la compra, sin costo adicional.
          </p>
        </div>

        <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-46" data-mp="qxirov2rs1i2">
          {BONOS.map((bono, i) => <motion.li key={bono.num} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.26,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(i, 3) * 0.04
        }} className="flex h-full items-start gap-3 overflow-hidden rounded-2xl border border-stone bg-white p-3 shadow-[0_14px_34px_-30px_rgba(25,23,19,0.6)]" data-id="element-47" data-mp="vsehrpog4esj" data-mpi={i}>
              <div className="relative h-[84px] w-[84px] shrink-0 overflow-hidden rounded-xl bg-sand sm:h-[96px] sm:w-[96px]" data-id="element-48" data-mp="10t2i51yke7zf">
                {bono.cover && <img src={bono.cover} alt="" loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-49" data-mp="1thzpia18mkde" />}
              </div>
              <div className="min-w-0 py-0.5" data-id="element-50" data-mp="235vij3eme6t4">
                <p className="font-display text-[0.58rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-51" data-mp="2376mb382fek8">
                  Bono {bono.num} · {bono.role}
                </p>
                <h3 className="mt-1 font-display text-[0.95rem] font-bold leading-tight tracking-tight text-charcoal" data-id="element-52" data-mp="1t8h7jjbgua87">
                  {bono.name}
                </h3>
                <p className="mt-1 font-sans text-[0.79rem] leading-snug text-taupe" data-id="element-53" data-mp="1kfds55h9fnax">{bono.desc}</p>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}